import type { TranslationKey } from './en.js';

export const fr: Partial<Record<TranslationKey, string>> = {
  'app.name': 'Volt',

  'section.chat': 'Chat',
  'section.image': 'Images',
  'section.video': 'Vidéo',
  'section.video2': 'Vidéo 2 (Marketing Studio)',
  'section.character': 'Personnage',
  'section.audio': 'Musique et audio',
  'section.voice': 'Voix',
  'section.design': 'Design',

  'common.loading': 'Chargement…',
  'common.error': 'Une erreur est survenue',
  'common.retry': 'Réessayer',
  'common.refresh': 'Actualiser',
  'common.cancel': 'Annuler',
  'common.confirm': 'Confirmer',
  'common.save': 'Enregistrer',
  'common.close': 'Fermer',
  'common.delete': 'Supprimer',
  'common.create': 'Créer',
  'common.apply': 'Appliquer',
  'common.offline': 'Hors ligne — données en cache affichées',
  'common.you': 'Vous',
  'common.assistant': 'Assistant',
  'common.empty': 'Rien ici pour l’instant',
  'common.back': 'Retour',

  'auth.loading': 'Connexion…',
  'auth.openInTelegram': 'Ouvrez-moi dans Telegram',
  'auth.openInTelegramHint':
    'Volt fonctionne comme une Mini App Telegram. Lancez-la depuis votre chat avec le bot pour vous connecter.',
  'auth.retry': 'Réessayer',
  'auth.error': 'Connexion impossible',
  'auth.devHint': 'Aperçu développeur — sans données Telegram.',

  'topbar.menu': 'Ouvrir le menu',
  'topbar.settings': 'Réglages',
  'topbar.balance': 'Solde',

  'directChat.open': 'Ouvrir le chat privé',
  'pager.chat': 'Chat',
  'pager.label': 'Changer de page',
  'directChat.title': 'Chat privé',
  'directChat.yourId': 'Votre ID : {id}',
  'directChat.addPlaceholder': 'ID public ou @nom_utilisateur Telegram',
  'directChat.addFriend': 'Ajouter un ami',
  'directChat.addSelf': 'Vous ne pouvez pas vous ajouter comme ami.',
  'directChat.friends': 'Amis',
  'directChat.noFriends':
    'Aucun ami pour le moment. Ajoutez quelqu’un avec son ID public ou son @nom_utilisateur Telegram.',
  'directChat.selectFriend': 'Choisissez un ami pour ouvrir la conversation.',
  'directChat.noMessages': 'Aucun message. Dites bonjour !',
  'directChat.messagePlaceholder': 'Écrire un message…',
  'directChat.send': 'Envoyer le message',
  'directChat.notFound': 'Aucun utilisateur trouvé avec cet ID ou nom d’utilisateur Telegram.',
  'directChat.noPermission': 'Vous pouvez écrire uniquement à un ami.',
  'directChat.addError':
    'Vérifiez l’ID ou le nom d’utilisateur ; cette personne est peut-être déjà ajoutée.',
  'directChat.error': 'Impossible de charger le chat. Réessayez.',
  'directChat.openDrawer': 'Ouvrir les conversations',
  'directChat.chats': 'Conversations',
  'directChat.groups': 'Groupes',
  'directChat.newGroup': 'Nouveau groupe',
  'directChat.createGroup': 'Créer le groupe',
  'directChat.groupName': 'Nom du groupe',
  'directChat.selectMembers': 'Sélectionner les membres ({count}/50 avec vous)',
  'directChat.memberCount': '{count} membres',
  'directChat.messages': 'Messages',
  'directChat.messageActions': 'Actions du message',
  'directChat.reply': 'Répondre',
  'directChat.replyingTo': 'Réponse à {name}',
  'directChat.forward': 'Transférer',
  'directChat.forwarded': 'Transféré',
  'directChat.chooseDestination': 'Choisir une conversation pour transférer',
  'directChat.deleteForMe': 'Supprimer pour moi',
  'directChat.deleteForEveryone': 'Supprimer pour tout le monde',
  'directChat.deleteForEveryoneConfirm': 'Supprimer ce message pour tout le monde dans la discussion ?',
  'directChat.aiAttribution': 'Intelligence Artificielle',
  'directChat.aiToggleEnabled': 'Réponses IA activées',
  'directChat.aiToggleDisabled': 'Réponses IA désactivées',
  'directChat.aiGenerating': "L'IA répond…",
  'directChat.aiGenerationError': 'Échec de la génération de la réponse IA : {error}',
  'directChat.aiChooseModel': 'Choisir le modèle IA',
  'directChat.aiLongPressHint': 'Maintenez enfoncé pour choisir le modèle',
  'directChat.sent': 'Envoyé',
  'directChat.delivered': 'Distribué',
  'directChat.read': 'Lu',

  'sidebar.title': 'Discussions',
  'sidebar.newChat': 'Nouveau chat',
  'sidebar.search': 'Rechercher',
  'sidebar.searchPlaceholder': 'Rechercher…',
  'sidebar.projects': 'Projets',
  'sidebar.newProject': 'Nouveau projet',
  'sidebar.noConversations': 'Aucune conversation',
  'sidebar.archived': 'Archivés',
  'sidebar.showArchived': 'Afficher les archives',
  'sidebar.hideArchived': 'Masquer les archives',
  'sidebar.pinned': 'Épinglés',
  'sidebar.today': 'Aujourd’hui',
  'sidebar.yesterday': 'Hier',
  'sidebar.previous7Days': '7 derniers jours',
  'sidebar.previous30Days': '30 derniers jours',
  'sidebar.older': 'Plus anciens',

  'menu.rename': 'Renommer',
  'menu.pin': 'Épingler',
  'menu.unpin': 'Désépingler',
  'menu.archive': 'Archiver',
  'menu.unarchive': 'Désarchiver',
  'menu.addToFolder': 'Ajouter au dossier',
  'menu.moveUp': 'Monter',
  'menu.moveDown': 'Descendre',
  'menu.delete': 'Supprimer',
  'menu.deleteTitle': 'Supprimer le chat ?',
  'menu.deleteConfirm': 'Cette conversation et ses messages seront supprimés définitivement.',

  'project.name': 'Nom du projet',
  'project.description': 'Description',
  'project.systemPrompt': 'Instructions personnalisées',
  'project.systemPromptHint':
    'Ces instructions sont envoyées au modèle pour chaque chat du projet.',
  'project.create': 'Créer le projet',
  'project.empty': 'Aucun projet',

  'composer.placeholder': 'Message pour Volt…',
  'composer.imagePlaceholder': 'Décrivez l’image voulue…',
  'composer.videoPlaceholder': 'Décrivez la vidéo voulue…',
  'composer.characterPlaceholder': 'Décrivez le personnage…',
  'composer.audioPlaceholder': 'Décrivez la musique ou l’audio…',
  'composer.voicePlaceholder': 'Texte à convertir en voix…',

  'character.tabSoulId': 'Soul ID',
  'character.tabCharacter': 'Personnage',
  'character.tabSoulCast': 'Soul Cast',
  'character.tabAiInfluencer': 'Influenceur IA',
  'character.soulIdTitle': 'Entraîner un Soul ID',
  'character.characterTitle': 'Personnages',
  'character.soulCastTitle': 'Soul Cast',
  'character.aiInfluencerTitle': 'Influenceurs IA',
  'character.name': 'Nom',
  'character.description': 'Description',
  'character.bio': 'Bio',
  'character.style': 'Style',
  'character.scene': 'Scène',
  'character.prompt': 'Prompt',
  'character.referenceImages': 'URLs d’images de référence, une par ligne',
  'character.pickSoulId': 'Sélectionnez un Soul ID',
  'character.pickCharacter': 'Sélectionnez un personnage',
  'character.noSoulLinked': 'Aucun Soul ID lié',
  'character.scopeLabel': 'Que créer',
  'character.scopeHead': 'Tête',
  'character.scopeFullBody': 'Corps entier',
  'character.scopeHeadHint': 'Les gros plans du visage sous différents angles donnent les meilleurs résultats.',
  'character.scopeFullBodyHint': 'Ajoutez des photos en pied pour construire tout le corps.',
  'character.scopeBadgeHead': 'Tête',
  'character.scopeBadgeFullBody': 'Corps entier',
  'character.model3dCreate': 'Créer le modèle 3D',
  'character.model3dView': 'Voir en 3D',
  'character.model3dBuilding': 'Création du modèle 3D… cela prend quelques minutes.',
  'character.model3dFailed': 'Impossible de créer le modèle 3D',
  'character.model3dRetry': 'Réessayer',
  'character.model3dStarted': 'Le modèle 3D est en cours de création',
  'character.model3dStage': 'Visionneuse du modèle 3D',
  'character.model3dLoading': 'Chargement du modèle…',
  'character.model3dError': 'Impossible d’ouvrir le modèle 3D.',
  'character.model3dUnsupported': 'Votre appareil ne prend pas en charge la 3D (WebGL).',
  'character.model3dHint': 'Faites glisser pour tourner · pincez ou utilisez la molette pour zoomer',
  'character.model3dReset': 'Réinitialiser la vue',
  'character.model3dAutoRotate': 'Rotation automatique',
  'character.soulIdPhotoHint': 'Téléversez 5 à 20 photos de référence.',
  'character.soulIdPhotoCount': 'Veuillez choisir entre 5 et 20 photos.',
  'character.soulIdUploadFailed': 'Impossible de téléverser les photos. Réessayez.',
  'character.createSoulId': 'Créer un Soul ID',
  'character.createCharacter': 'Créer un personnage',
  'character.createAiInfluencer': 'Créer un influenceur IA',
  'character.generateSoulCast': 'Générer un Soul Cast',
  'character.generateContent': 'Générer du contenu',
  'character.status.training': 'En entraînement',
  'character.status.ready': 'Prêt',
  'character.status.failed': 'Échec',
  'composer.send': 'Envoyer',
  'composer.stop': 'Arrêter',
  'composer.attach': 'Joindre des fichiers',
  'composer.attachTitle': 'Ajouter une pièce jointe',
  'composer.attachAllPhotos': 'Toutes les photos',
  'composer.attachCamera': 'Caméra',
  'composer.attachPhotos': 'Photos',
  'composer.attachFiles': 'Fichiers',
  'composer.attachFilesHint': 'Photos sans compression',
  'composer.attachToFolder': 'Ajouter au dossier',
  'composer.voiceInput': 'Saisie vocale',
  'composer.listening': 'Écoute…',
  'composer.thinking': 'Réflexion…',
  'composer.model': 'Modèle',
  'composer.selectModel': 'Choisir un modèle',
  'composer.unavailable': 'Indisponible',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': 'Rechargez votre solde jusqu’à {amount} pour continuer',
  'composer.generate': 'Générer',

  'message.copy': 'Copier',
  'message.copied': 'Copié',
  'message.share': 'Partager',
  'message.regenerate': 'Régénérer',
  'message.edit': 'Modifier',
  'message.save': 'Enregistrer et renvoyer',
  'message.up': 'Bonne réponse',
  'message.down': 'Mauvaise réponse',
  'message.usage': '{model} · {input} ent · {output} sort · {cost}',
  'message.usageNoModel': '{input} ent · {output} sort · {cost}',
  'message.failed': 'Échec de la génération',
  'message.reasoningTitle': 'Déroulé du traitement',
  'conversation.pinnedBadge': 'Discussion épinglée',

  // TODO: translate share keys
  'share.button': 'Share',
  'share.createLink': 'Create link',
  'share.copyLink': 'Copy link',
  'share.copied': 'Copied!',
  'share.revoke': 'Revoke link',
  'share.revokeConfirm':
    'Are you sure you want to revoke this link? Anyone with the link will no longer be able to access it.',
  'share.title': 'Share conversation',
  'share.sharedBy': 'Shared snapshot',
  'share.notFound': 'This link has expired or been revoked.',
  'share.openApp': 'Open Volt',
  'share.loading': 'Loading…',
  'share.sendToChat': 'Envoyer dans le chat',
  'share.noDestinations': 'Aucun chat ou groupe disponible',
  'share.sentSuccess': 'Envoyé !',
  'share.sending': 'Envoi en cours…',
  'share.loadingDestinations': 'Chargement des chats…',
  'artifact.preview': 'Aperçu',
  'artifact.code': 'Code',
  'artifact.open': 'Ouvrir l’artefact',
  'artifact.export': 'Exporter',
  'artifact.download': 'Télécharger',
  'artifact.copy': 'Copier',
  'artifact.edit': 'Modifier',
  'artifact.close': 'Fermer',
  'artifact.fullscreen': 'Plein écran',

  'job.status': 'Statut',
  'job.pending': 'En file',
  'job.processing': 'Traitement…',
  'job.done': 'Terminé',
  'job.failed': 'Échec',
  'job.cancelled': 'Annulé',
  'job.result': 'Résultat',
  'job.empty': 'Aucune génération',
  'job.actions': 'Actions',
  'job.favoriteAdd': 'Ajouter aux favoris',
  'job.favoriteRemove': 'Retirer des favoris',
  'job.favorited': 'Favori',
  'job.regenerate': 'Régénérer',
  'job.viewPrompt': 'Voir le prompt',
  'job.promptTitle': 'Prompt',
  'job.download': 'Télécharger',
  'job.deleteTitle': 'Supprimer cette génération ?',
  'job.deleteConfirm': 'Cette génération sera définitivement supprimée.',

  'design.subtitle': 'Ouvrez un outil de design dans une nouvelle fenêtre',
  'design.open': 'Ouvrir',

  'settings.title': 'Réglages',
  'settings.profile': 'Profil',
  'settings.appearance': 'Apparence',
  'settings.theme': 'Thème',
  'settings.themeLight': 'Clair',
  'settings.themeDark': 'Sombre',
  'settings.themeSystem': 'Système',
  'settings.language': 'Langue',
  'settings.balance': 'Solde',
  'settings.topup': 'Recharger',
  'settings.topupAmount': 'Montant, ₽',
  'settings.topupSubmit': 'Recharger le solde',
  'settings.transactions': 'Historique des transactions',
  'settings.noTransactions': 'Aucune transaction',
  'settings.loadMore': 'Charger plus',
  'settings.notifications': 'Notifications',
  'settings.notificationsHint': 'Être averti à la fin des générations',
  'settings.data': 'Vos données',
  'settings.exportData': 'Exporter mes données',
  'settings.deleteAccount': 'Supprimer le compte',
  'settings.deleteAccountTitle': 'Supprimer votre compte ?',
  'settings.deleteAccountConfirm':
    'Cela supprime définitivement votre compte, vos conversations et votre solde. Irréversible.',
  'settings.username': 'Identifiant',
  'settings.name': 'Nom',

  'admin.title': 'Admin',
  'admin.stats': 'Statistiques',
  'admin.users': 'Utilisateurs',
  'admin.settings': 'Réglages de la plateforme',
  'admin.markup': 'Marge, %',
  'admin.usdRub': 'Taux USD → RUB',
  'admin.minBalance': 'Solde min, ₽',
  'admin.contextLimit': 'Messages de contexte',
  'admin.models': 'Tarifs des modèles',
  'admin.price': 'Prix',
  'admin.revenue': 'Revenu',
  'admin.cost': 'Coût fournisseur',
  'admin.margin': 'Marge',
  'admin.activeUsers': 'Actifs (24 h)',
  'admin.failedJobs': 'Tâches échouées',
  'admin.ban': 'Bannir',
  'admin.unban': 'Débannir',
  'admin.adjustBalance': 'Ajuster le solde',
  'admin.reason': 'Motif',
  'admin.amount': 'Montant, ₽',
  'admin.errorHistory': 'Historique des erreurs',
  'admin.errorsEmpty': 'Aucune erreur enregistrée pour le moment.',

  'error.UNAUTHORIZED': 'Votre session a expiré. Rouvrez l’application.',
  'error.FORBIDDEN': 'Vous n’avez pas accès à cela.',
  'error.USER_BANNED': 'Votre compte a été suspendu.',
  'error.NOT_FOUND': 'Introuvable.',
  'error.RATE_LIMITED': 'Trop de requêtes. Ralentissez.',
  'error.DAILY_LIMIT_EXCEEDED': 'Limite quotidienne atteinte. Réessayez demain.',
  'error.INSUFFICIENT_BALANCE': 'Solde insuffisant pour cette requête.',
  'error.BELOW_MIN_BALANCE': 'Votre solde est sous le minimum requis.',
  'error.MODEL_UNAVAILABLE': 'Ce modèle est actuellement indisponible.',
  'error.MODEL_NOT_SUPPORTED': 'Ce modèle n’est pas pris en charge ici.',
  'error.PROVIDER_ERROR': 'Le fournisseur a renvoyé une erreur.',
  'error.PROVIDER_TIMEOUT': 'Le fournisseur n’a pas répondu à temps.',
  'error.CONTEXT_TOO_LARGE': 'Cette conversation est trop longue pour le modèle.',
  'error.PAYMENT_INVALID': 'Le paiement n’a pas pu être traité.',
  'error.INTERNAL': 'Erreur serveur. Réessayez.',
  'error.network': 'Erreur réseau. Vérifiez votre connexion.',
  'error.streamInterrupted': 'Connexion interrompue. La réponse a été récupérée depuis le serveur.',
  'error.generic': 'Une erreur est survenue.',
};
